import React from "react";
import styled from "styled-components";

const bgBlue= `${process.env.PUBLIC_URL}/img/bg-blue.jpg`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100px;

  background-color: #1A2732;;
  background-image: url(${bgBlue});
  background-repeat:  repeat-x;
  background-size: 100% auto;
`;

const Background = props => {
  return <Wrapper>{props.children}</Wrapper>;
};

export default Background;



// WEBPACK FOOTER //
// ./src/ui/Background.js